import { ConvertType, useFormatNumber } from '../../../hooks/useFormatNumber';
import { Input, InputProps } from '.';
import { forwardRef } from 'react';

interface InputWithUnitProps extends Omit<InputProps, 'unit'> {
  unit?: ConvertType;
  unitString?: string | React.ReactNode;
}

/** A number field with its unit inside, right behind the value ("0.93 m"); the field takes the full width. */
export const InputWithUnit = forwardRef<HTMLInputElement, InputWithUnitProps>(({ unit, unitString, ...props }, ref) => {
  const { unitChar } = useFormatNumber();
  return <Input ref={ref} {...props} unit={unit ? unitChar(unit) : unitString} />;
});

InputWithUnit.displayName = 'InputWithUnit';
